/**
 * @TODO: MOVE THIS TO SPORTS-COMMON
 * @param {String} currency
 */
const getCurrencySymbol = currency => {
    const value = new Number(0).toLocaleString('en-US', {
        style: 'currency',
        currency,
    });
    const zeroIndex = value.indexOf('0');
    return value.substring(0, zeroIndex);
};

export default getCurrencySymbol;
